import styles from '@src/components/FJModals/FJShareModal/FJShareContent/FJCommon.module.less';
import FJLoading from '@src/common/components/FJLoading/FJLoading.tsx';
import FJLocalStore from '@src/store/FJLocalStore';

const FJAITextLoading = () => {
    return (
        <div className={styles.input_mask}>
            <FJLoading strokeColor={'#9FA2AF'} />
            <p>{FJLocalStore._('AI prompt optimizing')}</p>
        </div>
    );
};

export default FJAITextLoading;
